// features/teacherSubjects/teacherSubjectsSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  teacherSubjects: {},
};

const teacherSubjectsSlice = createSlice({
  name: 'teacherSubjects',
  initialState,
  reducers: {
    setTeacherSubjects(state, action) {
      state.teacherSubjects = action.payload;
    },
  },
});

export const { setTeacherSubjects } = teacherSubjectsSlice.actions;
export default teacherSubjectsSlice.reducer;
